var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bean-source-page',{attrs:{"type":_vm.type,"filter-columns":_vm.filterColumns,"form":_vm.form,"title":_vm.$t('model.normalComment'),"batch-actions":_vm.batchActions,"resource":"normal_comments"},scopedSlots:_vm._u([{key:"table",fn:function(ref){
var value = ref.value;
return [(value && value.length)?_c('Table',{attrs:{"value":value}}):_c('div',[_c('p',{staticStyle:{"text-align":"center","padding":"50px 0"}},[_vm._v("暂无数据")])])]}},{key:"show",fn:function(ref){
var value = ref.value;
return [(value)?_c('ShowPage',{attrs:{"value":value}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }